export const translations = {
	'Use a variable': {},
	'Unknown variable': {},
};
